export const BROWSER_MEDIA_PERMISSION_ERROR_TYPE = {
  SystemPermissionDenied: 'system_permission_denied',
  UserPermissionDenied: 'user_permission_denied',
  CouldNotStartVideoSource: 'could_not_start_video_source',
  NotFound: 'not_found',
  Generic: 'generic'
};
export const CUSTOM_MEDIA_PERMISSION_ERROR_TYPE = {
  UserMediaNotAvailable: 'user_media_not_available'
};

export const CAMERA_PERMISSION_EXPLANATION_TEXT = {
  selfie: 'camera_permission.permission_explanation_selfie',
  default: 'camera_permission.permission_explanation_default'
};

export const CAMERA_PERMISSION_ERROR_PROPS = {
  [BROWSER_MEDIA_PERMISSION_ERROR_TYPE.SystemPermissionDenied]: {
    title: 'camera_permission.system_permission_denied.title',
    text: 'camera_permission.system_permission_denied.text',
    cancelButtonText: 'ok',
    approveButtonText: 'retry'
  },
  [BROWSER_MEDIA_PERMISSION_ERROR_TYPE.UserPermissionDenied]: {
    title: 'camera_permission.user_permission_denied.title',
    text: 'camera_permission.user_permission_denied.text',
    cancelButtonText: 'ok',
    approveButtonText: 'retry'
  },
  [BROWSER_MEDIA_PERMISSION_ERROR_TYPE.CouldNotStartVideoSource]: {
    title: 'camera_permission.could_not_start_video_source.title',
    text: 'camera_permission.could_not_start_video_source.text',
    cancelButtonText: 'ok',
    approveButtonText: 'retry'
  },
  [BROWSER_MEDIA_PERMISSION_ERROR_TYPE.NotFound]: {
    title: 'camera_permission.not_found.title',
    text: 'camera_permission.not_found.text',
    cancelButtonText: 'ok',
    approveButtonText: 'retry'
  },
  [BROWSER_MEDIA_PERMISSION_ERROR_TYPE.Generic]: {
    text: 'camera_permission.generic.text',
    approveButtonText: 'ok'
  },
  [CUSTOM_MEDIA_PERMISSION_ERROR_TYPE.UserMediaNotAvailable]: {
    text: 'camera_permission.user_media_not_available.text',
    approveButtonText: 'ok'
  }
};
